import ReactGA from "react-ga4";

const MEASUREMENT_ID = "G-HTF1QRSW24"; // твой Measurement ID
ReactGA.initialize(MEASUREMENT_ID);

export default ReactGA;
